var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 9.976 11.99 4l-1.428 1.42 3.622 3.603H2v2.009h12.097l-3.567 3.547L11.959 16l5.83-5.798-.008-.008.219-.218z",
  clipRule: "evenodd"
})));
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTggOS45NzZMMTEuOTkgNGwtMS40MjggMS40MiAzLjYyMiAzLjYwM0gydjIuMDA5aDEyLjA5N2wtMy41NjcgMy41NDdMMTEuOTU5IDE2bDUuODMtNS43OTgtLjAwOC0uMDA4LjIxOS0uMjE4eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";